import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
  FormFeedback,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane, // Import FormFeedback for error messages
} from "reactstrap";
import * as Yup from "yup"; // Import Yup for validation
import { useFormik } from "formik";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import MediaModal from "../../../Kangaroo/PagesSection/Component/MediaModal";
import WidgetService from "../../../services/KangarooServices/Intelligence/WidgetService";
import { imageBaseApi } from "../../../utilis/imageHelper";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";
import classnames from "classnames";
import RichTextEditor from "../../../Components/Editor/RichTextEditor";
import uploadImageApi from "../../../utilis/uploadImage";


const WidgetForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("1");
  const [childTab, setChildTab] = useState(0);
  const [selectedBannerMedia, setSelectedBannerMedia] = useState(null);
  const [selectedChildMedia, setSelectedChildMedia] = useState({});
  const [mediaSelectionType, setMediaSelectionType] = useState(null);
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const [mediaData, setMediaData] = useState([]);

  const [detailData, setDetailData] = useState({});
  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const authUser = getLoggedInUser();
  const isSuperAdmin = authUser.roles[0].includes("SuperAdmin");
  const isOnshoreAdmin = authUser.roles[0].includes("OnshoreAdmin");
  const toggleMedia = () => setIsMediaOpen(!isMediaOpen);

  // Fetch functions
  const fetchMedia = async () => {
    try {
      const response = await MediaService.getList({ page: 1, pageSize: 1000 });
      setMediaData(response.data || response);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPageDetail = async () => {
    try {
      const response = await WidgetService.getdetail(id);
      setDetailData(response);

      setSelectedMedia(response.image);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchMedia();
    if (id) fetchPageDetail();
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: detailData?.id || "",

      name: detailData?.name || "",
      type: 1,
      headingName: detailData?.headingName || "",
      description: detailData?.description || "",
      isExternalLink: detailData?.isExternalLink ?? false,
      url: detailData?.url || "",

      imageId: detailData?.imageId || "",
      image: detailData?.image?.url,

      // isOnshore:
      //   detailData?.isOnshore !== undefined
      //     ? detailData.isOnshore
      //     : isOnshoreAdmin,

      children:
        detailData?.children?.length > 0
          ? detailData.children
          : [
              {
                headingName: "",
                description: "",
                orderIndex: "",
                url: "",
                isPdf: false,
                mediaId: null,
                media: null,
              },
            ],
    },
    enableReinitialize: true,

    onSubmit: async (values) => {
      try {
        const payload = {
          name: values.name,
          type: Number(values.type),
          headingName: values.headingName,
          description: values.description,
          isExternalLink: Boolean(values.isExternalLink),
          // isOnshore: Boolean(values.isOnshore),
          imageId: selectedBannerMedia?.id || null,
          url: values?.url || "",

          children: values.children.map((c) => {
            const childPayload = {
              headingName: c.headingName,
              description: c.description,
              orderIndex: c.orderIndex === "" ? 0 : Number(c.orderIndex),
              url: c.url,
              isPdf: c.isPdf,
            };

            // ✅ Only include media fields if media is selected
            if (c.mediaId) {
              childPayload.mediaId = c.mediaId;
            }

            if (c.media) {
              childPayload.media = c.media;
            }

            return childPayload;
          }),
        };

        if (values?.id) {
          await WidgetService.update(values?.id, payload);
          toast.success("Widget updated successfully");
        } else {
          await WidgetService.create(payload);
          toast.success("Widget created successfully");
        }

        navigate(`/main-widgets`);
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong!");
      }
    },
  });

  const breadcrumbItems = [{ title: "Back to List", link: "/main-widgets" }];
  const PageTypeEnum = {
    SingleText: 1,
    ParagraphText: 2,
    List: 3,
    Image: 4,
  };
  const pageTypeOptions = Object.entries(PageTypeEnum).map(
    ([label, value]) => ({
      label,
      value,
    }),
  );
  const addTestStructure = () => {
    formik.setFieldValue("children", [
      ...formik.values.children,
      {
        id: "",
        headingName: "",
        description: "",
        orderIndex: "",
        url: "",
        isPdf: false,
        mediaId: "",
      },
    ]);
  };

  const removeTestStructure = (index) => {
    const updated = formik.values.children.filter((_, i) => i !== index);
    formik.setFieldValue("children", updated);
  };

  const updateTestStructure = (index, field, value) => {
    // const updated = [...formik.values.children];
    // updated[index][field] = value;
    // formik.setFieldValue("children", updated);
    formik.setFieldValue(
      "children",
      formik.values.children.map((ts, i) =>
        i === index ? { ...ts, [field]: value } : ts,
      ),
    );
  };

  const openMediaModal = (type, index = null) => {
    setMediaSelectionType({ type, index });
    setIsMediaOpen(true);
  };
  const handleMediaSelect = (media) => {
    if (mediaSelectionType?.type === "banner") {
      setSelectedBannerMedia(media);
      formik.setFieldValue("imageId", media.id);
    }

    if (mediaSelectionType?.type === "child") {
      const index = mediaSelectionType.index;

      setSelectedChildMedia((prev) => ({
        ...prev,
        [index]: media,
      }));

      formik.setFieldValue(`children[${index}].mediaId`, media.id);
      formik.setFieldValue(`children[${index}].media`, media);
    }

    setIsMediaOpen(false);
    setMediaSelectionType(null);
  };

  useEffect(() => {
    if (detailData?.children?.length > 0) {
      const mediaMap = {};
      detailData.children.forEach((child, index) => {
        if (child.media) {
          mediaMap[index] = child.media;
        }
      });
      setSelectedChildMedia(mediaMap);
    }
  }, [detailData]);
  const handlePdfChange = (file, index) => {
    if (file.type !== "application/pdf") {
      toast.error("Only PDF files are allowed");
      return;
    }

    // Set selectedChildMedia
    setSelectedChildMedia((prev) => ({
      ...prev,
      [index]: file,
    }));

    formik.setFieldValue(`children[${index}].mediaId`, file.id || null);
    formik.setFieldValue(`children[${index}].media`, file);
  };
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Widget Form"
          pageTitle="Widgets"
          breadcrumbItems={breadcrumbItems}
        />

        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {id ? "Update" : "Create"}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => navigate("/main-widgets")}
            >
              Cancel
            </button>
          </div>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggleTab("1")}
              >
                General Info
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggleTab("2")}
              >
                Widget Structures
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} className="mt-3">
            {/* General Info */}
            <TabPane tabId="1">
              <Row>
                <Col lg={8}>
                  <Card>
                    <CardBody>
                    
                      <FormGroup className="mb-3">
                        <Label htmlFor="name">Name</Label>
                        <Input
                          id="name"
                          name="name"
                          value={formik.values.name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={formik.touched.name && !!formik.errors.name}
                        />
                        {formik.touched.name && formik.errors.name && (
                          <FormFeedback>{formik.errors.name}</FormFeedback>
                        )}
                      </FormGroup>

                      <FormGroup className="mb-3">
                        <Label htmlFor="name">Sub Heading</Label>
                        <Input
                          id="headingName"
                          name="headingName"
                          value={formik.values.headingName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.headingName &&
                            !!formik.errors.headingName
                          }
                        />
                        {formik.touched.headingName &&
                          formik.errors.headingName && (
                            <FormFeedback>
                              {formik.errors.headingName}
                            </FormFeedback>
                          )}
                      </FormGroup>

                      {/* Content Field (CKEditor) */}
                      <FormGroup className="mb-3">
                        <Label>
                          Description <span className="text-danger">*</span>
                        </Label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={formik.values.description}
                          onChange={(event, editor) =>
                            formik.setFieldValue(
                              "description",
                              editor.getData(),
                            )
                          }
                          onBlur={() =>
                            formik.setFieldTouched("description", true)
                          } // Manual touch for validation
                        />
                        {/* Custom error display for CKEditor description */}
                        {formik.touched.description &&
                          formik.errors.description && (
                            <div
                              className="text-danger mt-1"
                              style={{ fontSize: "0.875em" }}
                            >
                              {formik.errors.description}
                            </div>
                          )}
                      </FormGroup>

                  
                    </CardBody>
                  </Card>
                </Col>

                <Col lg={4}>
                  <Card>
                    <CardBody>
                      <Label>Featured Media</Label>

                      {selectedBannerMedia ? (
                        <div className="text-center p-3 border rounded shadow-sm bg-light">
                          <div
                            style={{
                              maxHeight: "220px",
                              overflow: "hidden",
                              borderRadius: "10px",
                              border: "1px solid #ddd",
                            }}
                            className="mb-3"
                          >
                            <img
                              src={`${imageBaseApi}${selectedBannerMedia?.url}`}
                              alt="Featured"
                              style={{ width: "100%", objectFit: "cover" }}
                              className="img-fluid"
                            />
                          </div>

                          <div className="mb-2">
                            <div className="fw-semibold">
                              {selectedBannerMedia.name || "Featured Image"}
                            </div>

                            {selectedBannerMedia.size && (
                              <small className="text-muted">
                                Size:{" "}
                                {(selectedBannerMedia.size / 1024).toFixed(1)}{" "}
                                KB
                              </small>
                            )}
                          </div>

                          <div className="d-flex gap-2 justify-content-center">
                            <Button
                              size="sm"
                              outline
                              color="primary"
                              onClick={() => openMediaModal("banner")}
                            >
                              Change
                            </Button>

                            <Button
                              size="sm"
                              outline
                              color="danger"
                              onClick={() => {
                                setSelectedBannerMedia(null);
                                formik.setFieldValue("imageId", null);
                              }}
                            >
                              Remove
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div className="p-4 border rounded text-center bg-light">
                          <h6 className="mb-3 text-muted">No image selected</h6>

                          <Button
                            outline
                            color="secondary"
                            onClick={() => openMediaModal("banner")}
                          >
                            Choose Featured Image
                          </Button>
                        </div>
                      )}
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <FormGroup className="mb-3">
                        <Label htmlFor="name">Heading Url</Label>
                        <Input
                          id="url"
                          name="url"
                          value={formik.values.url}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={formik.touched.url && !!formik.errors.url}
                        />
                        {formik.touched.url && formik.errors.url && (
                          <FormFeedback>{formik.errors.url}</FormFeedback>
                        )}
                      </FormGroup>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between mb-3">
                    <h5>Details</h5>

                    <Button
                      color="success"
                      size="sm"
                      onClick={() => {
                        addTestStructure();
                        setChildTab(formik.values.children.length);
                      }}
                    >
                      + Add Section
                    </Button>
                  </div>

                  {/* CHILD TABS HEADER */}
                  <Nav pills className="mb-3 gap-2">
                    {formik.values.children.map((_, index) => (
                      <NavItem
                        key={index}
                        className="d-flex align-items-center"
                      >
                        <NavLink
                          className={classnames({
                            active: childTab === index,
                            "cursor-pointer d-flex align-items-center": true,
                          })}
                          onClick={() => setChildTab(index)}
                        >
                          {/* Dynamic Tab Label */}
                          {formik.values.children[index].headingName
                            ? formik.values.children[index].headingName
                            : `Section ${index + 1}`}

                          {/* Close Button */}
                          <span
                            className="ms-2 text-danger"
                            style={{ cursor: "pointer", fontWeight: "bold" }}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent tab switch
                              removeTestStructure(index);
                              // Adjust active tab
                              if (
                                childTab >=
                                formik.values.children.length - 1
                              ) {
                                setChildTab(
                                  formik.values.children.length - 2 >= 0
                                    ? formik.values.children.length - 2
                                    : 0,
                                );
                              }
                            }}
                          >
                            ×
                          </span>
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>

                  {/* CHILD TAB CONTENT */}
                  <TabContent activeTab={childTab}>
                    {formik.values.children.map((ts, index) => (
                      <TabPane key={index} tabId={index}>
                        <Card className="border shadow-sm">
                          <CardBody>
                            {/* Heading */}

                            <Row>
                              <Col lg={8}>
                                <FormGroup>
                                  <Label>Heading</Label>
                                  <Input
                                    value={ts.headingName}
                                    onChange={(e) =>
                                      updateTestStructure(
                                        index,
                                        "headingName",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <Label>Order Index</Label>
                                  <Input
                                    type="number" // ← also recommended
                                    value={ts.orderIndex ?? ""}
                                    onChange={(e) =>
                                      updateTestStructure(
                                        index,
                                        "orderIndex",
                                        e.target.value === ""
                                          ? ""
                                          : Number(e.target.value),
                                      )
                                    }
                                  />
                                </FormGroup>
                                {!ts.isPdf && (
                                  <FormGroup>
                                    <Label>Url</Label>
                                    <Input
                                      value={ts.url}
                                      onChange={(e) =>
                                        updateTestStructure(
                                          index,
                                          "url",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </FormGroup>
                                )}
                              </Col>

                              <Col md={4} key={index}>
                                <Card>
                                  <CardHeader>
                                    <FormGroup className="d-flex justify-content-between">
                                      <Label>Is Pdf?</Label>
                                      <Input
                                        type="checkbox"
                                        checked={ts.isPdf || false}
                                        onChange={(e) =>
                                          updateTestStructure(
                                            index,
                                            "isPdf",
                                            e.target.checked,
                                          )
                                        }
                                      />
                                    </FormGroup>
                                  </CardHeader>

                                  {ts.isPdf && (
                                    <CardBody>
                                      <Label>Upload PDF</Label>

                                      {selectedChildMedia[index] ? (
                                        <div className="text-center p-3 border rounded shadow-sm bg-light">
                                          <div className="mb-2">
                                            <div className="fw-semibold">
                                              {selectedChildMedia[index]
                                                ?.fileName || "PDF File"}
                                            </div>

                                            {selectedChildMedia[index]
                                              ?.size && (
                                              <small className="text-muted">
                                                Size:{" "}
                                                {(
                                                  selectedChildMedia[index]
                                                    .size / 1024
                                                ).toFixed(1)}{" "}
                                                KB
                                              </small>
                                            )}
                                          </div>

                                          <div className="d-flex gap-2 justify-content-center">
                                            <Button
                                              size="sm"
                                              outline
                                              color="primary"
                                              onClick={() =>
                                                openMediaModal("child", index)
                                              }
                                            >
                                              Change
                                            </Button>

                                            <Button
                                              size="sm"
                                              outline
                                              color="danger"
                                              onClick={() => {
                                                setSelectedChildMedia(
                                                  (prev) => {
                                                    const updated = { ...prev };
                                                    delete updated[index];
                                                    return updated;
                                                  },
                                                );

                                                formik.setFieldValue(
                                                  `children[${index}].mediaId`,
                                                  null,
                                                );
                                                formik.setFieldValue(
                                                  `children[${index}].media`,
                                                  null,
                                                );
                                              }}
                                            >
                                              Remove
                                            </Button>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="p-4 border rounded text-center bg-light">
                                          <h6 className="mb-3 text-muted">
                                            No PDF selected
                                          </h6>
                                          <Button
                                            outline
                                            color="secondary"
                                            onClick={() =>
                                              openMediaModal("child", index)
                                            }
                                          >
                                            Choose PDF
                                          </Button>
                                        </div>
                                      )}
                                    </CardBody>
                                  )}
                                </Card>
                              </Col>
                            </Row>

                            {/* Description */}
                            <FormGroup>
                              <Label>Description</Label>

                           
                              <RichTextEditor
                                formik={formik}
                                // fieldName="description"
                                fieldName={`children.${index}.description`}
                                uploadImageApi={uploadImageApi}
                              />
                            </FormGroup>

                            
                          </CardBody>
                        </Card>
                      </TabPane>
                    ))}
                  </TabContent>
                </CardBody>
              </Card>
            </TabPane>
          </TabContent>
        </form>
      </div>

      <MediaModal
        isOpen={isMediaOpen}
        toggle={() => setIsMediaOpen(false)}
        mediaData={mediaData}
        selectedMedia={
          mediaSelectionType?.type === "banner"
            ? selectedBannerMedia
            : mediaSelectionType?.type === "child"
            ? selectedChildMedia[mediaSelectionType.index]
            : null
        }
        setSelectedMedia={handleMediaSelect}
      />
    </Container>
  );
};

export default WidgetForm;
